import { render, staticRenderFns } from "./MaterialityCountCard.vue?vue&type=template&id=d51f34c6"
import script from "./MaterialityCountCard.vue?vue&type=script&lang=js"
export * from "./MaterialityCountCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports